import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import FixedItineraryPeriodicHikeDrawer from "components/drawer/FixedItineraryPeriodicHikeDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import dayjs from "dayjs";

const FixedItineraryPeriodicHikeTable = ({
  fixedItineraryPeriodicHike,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const fixedItineraryPeriodicHikesorted = fixedItineraryPeriodicHike.sort(
    (a, b) => a.city_names.localeCompare(b.city_names)
  );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <FixedItineraryPeriodicHikeDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {fixedItineraryPeriodicHikesorted
          ?.slice(0, perpage)
          .map((data, index) => (
            <React.Fragment key={data.id}>
              {data["vehicle_type_id"].map((item, vehicleIndex) => (
                <TableRow key={`${data.id}-${vehicleIndex}`}>
                  {/* Only display Sl.No., City, Start Date, and End Date on the first row of each grouped vehicle type */}
                  {vehicleIndex === 0 && (
                    <>
                      <TableCell
                        className="text-center text-xs"
                        rowSpan={data["vehicle_type_id"].length}
                      >
                        {(currentPage - 1) * perpage + index + 1}
                      </TableCell>

                      <TableCell
                        rowSpan={data["vehicle_type_id"].length}
                        className="text-center text-xs"
                      >
                        {data["city_names"]}
                      </TableCell>

                      <TableCell
                        className="text-center text-xs"
                        rowSpan={data["vehicle_type_id"].length}
                      >
                        {dayjs(data["start_date"]).format("DD-MM-YYYY")}
                      </TableCell>

                      <TableCell
                        className="text-center text-xs"
                        rowSpan={data["vehicle_type_id"].length}
                      >
                        {dayjs(data["end_date"]).format("DD-MM-YYYY")}
                      </TableCell>
                    </>
                  )}

                  {/* Render each vehicle type and hike percentage in individual cells */}
                  <TableCell className="text-center text-xs">
                    {data["vehicle_type_names"][item]}
                  </TableCell>

                  <TableCell className="text-center text-xs">
                    {data["hike"][item] + "%"}
                  </TableCell>

                  {/* Only display Actions on the first row of each grouped vehicle type */}
                  {vehicleIndex === 0 && (
                    <TableCell rowSpan={data["vehicle_type_id"].length}>
                      <div className="flex justify-center">
                        <EditDeleteButton
                          title={data["Airport Pickup"]}
                          id={data.id}
                          handleUpdate={handleUpdate}
                          handleModalOpen={handleModalOpen}
                          hideEdit={hideEdit}
                          hideDelete={hideDelete}
                        />
                      </div>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </React.Fragment>
          ))}
      </TableBody>
    </>
  );
};

export default FixedItineraryPeriodicHikeTable;
